import { render } from "./table_details_component.vue?vue&type=template&id=75711d57"
import script from "./table_details_component.vue?vue&type=script&lang=js"
export * from "./table_details_component.vue?vue&type=script&lang=js"

import "./table_details_component.vue?vue&type=style&index=0&id=75711d57&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__